$(document).ready(function() {
	if ($.cookie('oldEnough') !== undefined) {
		initHome();
	} else {
      $("#ageOverlay").removeClass("disabled");
    }
});

$(window).scroll(function() {
	if($(window).scrollTop() > 30) {
		if ($("nav").hasClass('fadedNav')) {
			//do nothing
		} else {
			fadeInHeader();
		}
		
	} else {
		if ($("nav").hasClass('fadedNav')) {
			//do nothing
		} else {
			fadeOutHeader();
		}
	}
});

$("#oldEnoughBTN").on("click", function() {

	document.cookie = "oldEnough=true";

	$("#ageOverlay").css("opacity", "0");
	$("#ageOverlay").css("pointer-events", "none");
	$("body").removeClass("noScroll");
	setTimeout(initHome, 500);

});

$("#notOldEnoughBTN").on("click", function() {
	$("#agePrompt").hide();
	$("#notOldEnoughMessage").show();
});

function initHome() {
	$("#homeSplashLeft").removeClass("tuckedAway");
	$("#homeSplashRight").removeClass("tuckedAway");
}
function fadeInHeader() {
	
	$("nav").addClass("fadedNav");
}
function fadeOutHeader() {
	
	$("nav").removeClass("fadedNav");
}

let burgerOpen = 0;

$("#burgerBTN").on("click", function() {
  if (burgerOpen == 0) {
    $("#navLinks").css("right", "0px");
    $("#burgerIcon").css("opacity", "0");
    $("#closeIcon").css("opacity", "1");
    burgerOpen = 1;
  } else {
    $("#navLinks").css("right", "-250px");
    $("#burgerIcon").css("opacity", "1");
    $("#closeIcon").css("opacity", "0");
    burgerOpen = 0;
  }
});
$(".navDropDown").on("click", function() {
  $(this).find('.subNav').each(function() {
    $(this).css('max-height', '500px');
  });
});